export const RegistrationLeaveLiabilityWaiverModalSelectors = {
  block: "RegistrationLeaveLiabilityWaiverModal",
  accept: "RegistrationLeaveLiabilityWaiverModal__accept",
  decline: "RegistrationLeaveLiabilityWaiverModal__decline",
  body: "RegistrationLeaveLiabilityWaiverModal__body",
};
